<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <b-form-group>
            <label class="form-control-label">{{ $t('views.agreements.list.agreementNumber') }}:</label>
            <input :placeholder="$t('views.exsbdocument.list.number')" v-model.lazy="filters.number" v-debounce="delay" class="form-control" type="text">
          </b-form-group>
        </b-col>
        <b-col v-if="agreementTagOptions.length > 0">
          <b-form-group>
            <label>{{$t("views.agreements.form.tags")}}: </label>
            <multi-select :options="agreementTagOptions" :selected-options="tagsFilter" @select="onSelectTags" >
            </multi-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <label class="form-control-label">
              {{ $t('views.agreements.list.userData') }}:
            </label>
            <base-select-input
              v-model="filters.idClient"
              :search-callback="userDataSearchCallback"
              :query-param="'userdata'"
              :display-values="['fullName', 'firmname1']"
              :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
            ></base-select-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="priceGroupsOptions.length > 0">
          <b-form-group>
            <label>{{$t("views.exsbitems.form.priceGroup")}}: </label>
            <multi-select :options="priceGroupsOptions" :selected-options="priceGroupsFilter" @select="onSelectPriceGroups">
            </multi-select>
          </b-form-group>
        </b-col>
        <b-col v-if="itemOptions.length > 0">
          <b-form-group>
            <label>{{$t("views.exsbitems.list.title")}}: </label>
            <multi-select :options="itemOptions" :selected-options="itemsFilter" @select="onSelectItems">
            </multi-select>
          </b-form-group>
        </b-col>
        <b-col v-if="itemsFilter.length === 1">
          <label>{{$t("views.agreements.list.priceUserDataFrom")}}: </label>
          <input :placeholder="$t('views.agreements.list.priceUserDataFrom')" v-model.lazy="filters['agreementItems.priceUserData.priceBrutto[gt]']" v-debounce="delay" class="form-control" type="number">
        </b-col>
        <b-col v-if="itemsFilter.length === 1">
          <label>{{$t("views.agreements.list.priceUserDataTo")}}: </label>
          <input :placeholder="$t('views.agreements.list.priceUserDataTo')" v-model.lazy="filters['agreementItems.priceUserData.priceBrutto[lt]']" v-debounce="delay" class="form-control" type="number">
        </b-col>
        <b-col>
          <label>{{ $t('views.agreements.list.date') }}:</label>
          <b-form-group>
            <b-form-radio-group
              v-model="filters.dateStatusFilter"
              :options="radioOptionsDateStatus"
              buttons
              button-variant="outline-primary"
              name="radios-btn-default"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import debounce from 'v-debounce'
import getId from '@/utils/getIdFromLink'
import { MultiSelect } from 'vue-search-select'
import ApiService from '@/utils/ApiService'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'
import { mapActions, mapGetters } from 'vuex'
import addParamsToQuery from '@/utils/addParamsToQuery'

export default {
  name: 'AgreementFiltering',
  components: { BaseSelectInput, MultiSelect },
  props: ['filters', 'filterReference'],
  data () {
    return {
      agreementTagOptions: [],
      delay: 500,
      tagsFilter: [],
      itemsFilter: [],
      priceGroupsFilter: [],
      loading: false,
      radioOptionsDateStatus: [
        { value: '', text: this.$t('menu.agreements.listAll') },
        { value: 1, text: this.$t('views.excmcase.list.searchParams.activeOnly') },
        { value: 2, text: this.$t('views.excmcase.list.searchParams.inactiveOnly') }
      ]
    }
  },

  directives: {
    debounce
  },

  watch: {
    filters: {
      deep: true,
      handler () {
        if (this.itemsFilter.length !== 1) {
          this.filters['agreementItems.priceUserData.priceBrutto[gt]'] = ''
          this.filters['agreementItems.priceUserData.priceBrutto[lt]'] = ''
          this.filters['agreementItems.priceUserData.item'] = ''
        } else if (this.filters['agreementItems.priceUserData.priceBrutto[lt]'] || this.filters['agreementItems.priceUserData.priceBrutto[lt]']) {
          this.filters['agreementItems.priceUserData.item'] = this.itemsFilter[0].value
        }
        this.filter()
      }
    }
  },

  created () {
    this.fetchAgreementTagOptions()
    this.getItems()
    this.getPriceGroups()
  },
  computed: {
    ...mapGetters({
      items: 'exsbitem/list/items',
      priceGroups: 'exsbitem/list/priceGroupOptions'
    }),
    itemOptions () {
      if (!this.items) return []
      return this.items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.name
        }
      })
    },
    priceGroupsOptions () {
      if (!this.priceGroups) return []
      return this.priceGroups
    }
  },
  methods: {
    ...mapActions({
      fetchItems: 'exsbitem/list/getItems',
      fetchPriceGroups: 'exsbitem/list/getPriceGroups'
    }),
    getItems () {
      let link = addParamsToQuery('e_x_s_b_items', {
        pagination: false
      })
      this.fetchItems(link)
    },
    getPriceGroups () {
      let link = addParamsToQuery('e_x_s_b_price_groups', {
        pagination: false
      })
      this.fetchPriceGroups(link)
    },
    filter () {
      this.$emit('filterAgreements', this.filters)
    },
    clearFilters () {
      this.tagsFilter = []
      this.itemsFilter = []
      this.priceGroupsFilter = []
      this.filters = Object.assign(this.filters, this.filterReference)
    },
    async fetchAgreementTagOptions () {
      let baseParams = { pagination: false, tagType: 1 }
      const response = await new ApiService('e_x_c_m_tags', baseParams).getResults()
      this.agreementTagOptions = response.items.map(tag => {
        return {
          value: tag['@id'],
          text: tag.tag
        }
      })
    },
    onSelectTags (agreements, lastSelectItem) {
      this.filters['agreementTags.tag'] = agreements.map(agreement => {
        return agreement.value
      })
      this.tagsFilter = agreements
      this.lastSelectTag = lastSelectItem
    },
    onSelectItems (items, lastSelectItem) {
      this.filters['agreementItems.item'] = items.map(item => {
        return item.value
      })
      this.itemsFilter = items
      this.lastSelectItem = lastSelectItem
    },
    onSelectPriceGroups (priceGroups, lastSelectItem) {
      this.filters['agreementItems.priceGroup'] = priceGroups.map(priceGroup => {
        return priceGroup.value
      })
      this.priceGroupsFilter = priceGroups
      this.lastSelectPriceGroup = lastSelectItem
    },
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
